import React, { useState } from 'react';
import data from '../../Data/dataClient.json';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './css/client.css';
import Sidebar from '../../components/SidebarClient';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { suprimerClient } from '../../Redux/actions/actionClient';
import { suprimerUrlClient } from '../../Redux/actions/actionUrlClient';
import { useDispatch, useSelector } from 'react-redux';

const Client = () => {
  const [show, setShow] = useState(false);
  const [select, setSelecte] = useState("");

  let navigate = useNavigate();
  let dispatch = useDispatch();
  let urlClient = useSelector((state) => state.urlClient);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChange = (e) => {
    setSelecte(e.target.value.title);
    if (e.target.value !== '') {
      navigate(e.target.value.path);
    } else {
      setSelecte("Mon compte...");
    }

  }

  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #4ba7cc',
      fontSize: 14,
      width: 180,

      color: 'rgb(62 73 88)',
      // padding: '4px 10px 6px 10px',
      height: 15,
      boxShadow: '#70c4e7 0px 1px 4px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#4ba7cc',
        boxShadow: 'none',
        backgroundColor: 'white'
      },
    },
  }))(InputBase);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/loginClient');
    dispatch(suprimerClient());

  }

  console.log("Url client=>", urlClient);

  const handleSociete = () => {
    localStorage.removeItem('client');
    localStorage.removeItem('tokenClient');
    localStorage.removeItem('urlClientSociete');
    dispatch(suprimerUrlClient());
    if (urlClient === "/societe/gererClient") {
      navigate('/societe/gererClient');
    }
  }

  return (
    <div className='client'>
      <div className='main'>
        <div className='sidebar_full'>
          <Sidebar hide={handleClose} logout={handleLogout} />
        </div>
        <div className='bloc_client'>
          <div className='nav fixed-top'>
            <div className='w-100 d-flex justify-content-between'>
              <div className='d-flex'>
                <i className='fa fa-navicon' onClick={handleShow}></i>
                <Link to="/" title='accueil' className='lien_retour'><span className='retourAccueil'><i className='fa fa-home'></i> <i className='retourLettre'>Retour à la page d'accueil</i></span></Link>
                {localStorage.getItem('urlClient') && <Link to={localStorage.getItem('urlClient')} title='reservation' className='lien_retour'><span className='retourAccueil'><i className='fa fa-cutlery'></i> <i className='retourLettre'>Retour à la Réseservation</i></span></Link>}

              </div>
              <div className="right">
                {localStorage.getItem('urlClientSociete') &&
                  <div className='quitter' onClick={handleSociete}>
                    <span>Quitter</span>
                  </div>}
                <div className='select_navigation'>
                  <FormControl>
                    <Select
                      id="demo-customized-select"
                      onChange={handleChange}
                      value={select}
                      displayEmpty
                      renderValue={(value) => value !== "" ? value : <em>Mon compte ...</em>}
                      input={<BootstrapInput />}
                    >
                      <MenuItem value="" >Mon compte</MenuItem>
                      {data.map((el, index) => {
                        return (
                          <MenuItem value={el} key={index}>{el.title}</MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </div>
                <div className='deconnect' onClick={handleLogout}>
                  <span>Se déconnecter</span>
                </div>
              </div>
            </div>
          </div>
          <Outlet />
        </div>
        <div className='content_offcanvas'>
          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Body>
              <div className='sidebar_mobileClient'>
                <Sidebar hide={handleClose} />
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </div>
  )
}

export default Client